{
  "en": {
    "lead": {
      "actions": {
        "add_company": "Add company",
        "add_lead": "Add lead",
        "new": "Lead"
      },
      "attributes": {
        "address": "Address",
        "birth_date": "Date of birth",
        "categories": {
          "enduser": "Buyer-Occupier",
          "investor": "Investor"
        },
        "category": "Lead Type",
        "company_name": "Company name",
        "company_vat": "VAT number",
        "email_address": "Email",
        "first_name": "First name",
        "iban": "IBAN",
        "internal_note": "Internal Note",
        "language": "Language",
        "last_name": "Last name",
        "phone_landline": "Landline number",
        "phone_mobile": "Mobile number",
        "status": "Status"
      },
      "labels": {
        "detailed_information": "Enter detailed information",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "First name required",
        "needLastName": "Last name required"
      }
    }
  }
}